module.exports = __webpack_public_path__ + "img/3.4.c64d147a.png";